module.exports = __webpack_public_path__ + "img/medic-concepts.e841afb0.svg";